<template>
  <nav :class="{shrink}" v-on-clickaway="closeNavMobile" class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <md-button type="button" @click="toggleNavMobile" class="screen-reader mobile-hamburger">
          <span class="sr-only">{{$t('header.NAV_SR_TOGGLE_TEXT')}}</span>
          <md-icon>menu</md-icon>
        </md-button>
        <brave-link to="/"><img @click="closeNavMobile" :src="brandLogoSrc" alt="Bravenet"></brave-link>
      </div>
      <div class="vertical-divider"/>
      <div id="navbar" class="collapse navbar-collapse" :class="{open: mobileNavOpen}">
        <ul :class="currentlyActive()" class="nav navbar-nav">
          <li @click="closeNavMobile" class="homelink" style="display: none;">
            <a href="index.php"><md-button>{{$t('header.HOME')}}</md-button></a>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" is-external to="https://siteblocks.com/features" class="major-link features-link">{{$t('sitebuilder.header.FEATURES_LINK')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" to="/sitebuilder/templates?from=siteblocks" class="major-link siteblocks-templates-link">{{$t('sitebuilder.header.TEMPLATES_LINK')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" is-external to="https://help.siteblocks.com" class="major-link help-center-link">{{$t('sitebuilder.header.HELP_CENTER_LINK')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" is-external to="https://siteblocks.com/getting-started" class="major-link contact-link">{{$t('sitebuilder.header.CONTACT_LINK')}}</brave-link>
          </li>
        </ul>
        <div class="navbar-right" @click="closeNavMobile">
          <md-button style="color: #fff;" :to="{path: '/login', query: navQuery()}" class="md-raised md-primary full-width">
            {{$t('header.NAV_LOGIN_TEXT')}}
          </md-button>
          <md-button style="color: #fff;" :to="{path: '/login', query: navQuery()}" class="md-raised md-primary reduced-width">
            {{$t('header.NAV_LOGIN_REDUCED_TEXT')}}
          </md-button>
          <md-button style="color: #fff;" :to="{path: '/register', query: navQuery()}" class="md-raised md-accent">
            {{$t('header.NAV_REGISTER_TEXT')}}
          </md-button>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import {HEADER_NAV_FLYOUT_ITEMS, LEGACY_SERVICE_MAPPING} from 'app-constants'
import style from 'styles/siteblocks-header.scss'
import flyout from 'brave-flyout/components/flyout'
import {scrollCoordinates} from 'brave-utils/window'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  mixins: [clickaway],
  created() {
    this.decideShouldShrink()
    window.addEventListener('scroll', this.decideShouldShrink)
  },
  methods: {
    decideShouldShrink() {
      this.shrink = scrollCoordinates().top > 0
    },
    currentlyActive() {
      const { fullPath } = this.$route;
      const pathWithoutQuery = fullPath.split('?')[0];
      const modifiedPath = pathWithoutQuery.replace(/\//g, '-'); // Replace / with -
      const validPaths = ['', 'siteblocks-templates', 'features'];
      return validPaths.includes(modifiedPath) ? modifiedPath : 'siteblocks-templates';
    },
    closeNavMobile () {
      this.mobileNavOpen = false

    },
    toggleNavMobile () {
      this.mobileNavOpen = !this.mobileNavOpen
      this.$refs['services-dropdown'].toggle()
    },
    closeAll (itemHandler) {

      itemHandler()
      this.closeNavMobile()
    },
    navQuery () {
      let view = this.$route.fullPath.substr(1)
      let legacyService = LEGACY_SERVICE_MAPPING[view]
      let query = (legacyService)
          ? {from: legacyService}
          : null
      return query
    }
  },
  data() {
    let flyoutItems = HEADER_NAV_FLYOUT_ITEMS

    return {
      flyoutItems,
      shrink: this.shrink,
      mobileNavOpen: false
    }
  },
  components: {
    'flyout': flyout
  },
  computed: {
    brandLogoSrc() {
      // Check if the 'brand' query parameter is set to 'siteblocks'
      if (this.$route.query.brand === 'siteblocks' || this.$route.query.from === 'siteblocks') {
        return require('assets/img/shared/siteblocks_logo.svg');
      } else {
        return require('assets/img/shared/bravenet_logo.png');
      }
    }
  },
}
</script>


// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/siteblocks-header.vue